import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SaveIcon = ({ color = '#B5BCBD', size = 20, ...props }) => (
  <svg
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M8.901 1.087v11.739L4.967 9.065a1.174 1.174 0 0 0-1.624 0 1.04 1.04 0 0 0 0 1.544L10.068 17l6.61-6.39a1.058 1.058 0 0 0-.024-1.544c-.457-.435-1.167-.413-1.624.022l-3.287 3.16-.555.534V1.087C11.188.478 10.685 0 10.044 0c-.64 0-1.143.478-1.143 1.087z"
        fill={color}
      />
      <path
        d="M15.856 18H4.144C3.504 18 3 18.44 3 19s.503 1 1.144 1h11.712c.64 0 1.144-.44 1.144-1s-.503-1-1.144-1z"
        fill={color}
      />
    </g>
  </svg>
);

SaveIcon.propTypes = propTypes;

export default SaveIcon;
